import React from "react";
import { Modal } from '@arco-design/web-react';
import styles from "./index.module.scss";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LazyMedia from "@/components/LazyMedia";
const softBanner1 = require('../../assets/soft_bg_pico_cast 1.png')
interface ISoftware{
  castForPicoList: Record<string, any>[]; // cast下载列表
  words: Record<string, string>;
}

const SoftwareFooter:React.FC<ISoftware> = ({castForPicoList,words})=> {
    let [visible, setVisible] = React.useState(false);
    let castForPicoLists=castForPicoList[0] // cast下载列表
    const location = useLocation();
    // 监听hash变化，滚动到锚点
    useEffect(() => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView();
        }
      }
    }, [location]);


    return (
      <>
      <div className={styles.downloadFooter} id="cast">
        <div className={styles.download1}>
          <div className={styles.download1Tittle}>
            <p className={styles.textTittle}>{words.software_cast_title}</p>
            <p className={styles.textContent}>{words.software_cast_content}</p>
            <button className={styles.downloadBtn} onClick={() => setVisible(true)}>{words.software_download}</button>
          </div>
          <LazyMedia type="image" LazyClassName='full-wh' src={softBanner1}  className={`${styles.bannerImg} ${visible ? styles.bannerImgBtn :""}`}/>
          <div className={styles.download}>
            <div className={styles.dialogLine}></div>
            <a className={styles.downloadBtn1} href={castForPicoLists?.url} download="">{words.software_download}</a>
            <div className={styles.downloadDetails}>
              <div className={styles.downloadDetailsText}>
                  <h3>{words.software_Notes}</h3>
                  <div className={styles.downloadDetailsTextContent}>
                    {castForPicoLists?.updateInfo}
                  </div>

                  <h3>{words.software_New}</h3>
                  <div className={styles.downloadDetailsTextContent}>
                    {castForPicoLists?.updateContent}
                  </div>

              </div>
              <div className={styles.downloadDetailsText}>
                  <h3>{words.software_Requirements}</h3>
                  <div className={styles.downloadDetailsTextContent}>
                    {castForPicoLists?.configurationRequirements}
                  </div>

              </div>
            </div>
          </div>
        </div>
          <Modal
              title=''
              visible={visible}
              onOk={() => setVisible(false)}
              onCancel={() => setVisible(false)}
              autoFocus={false}
              focusLock={true}
              className={styles.footerDialog}
          >
              <p className={styles.dialogTittle}>{words.software_download}</p>
              <div className={styles.dialogLine}></div>
              <a className={styles.downloadBtn} href={castForPicoLists?.url} download="">{words.software_download}</a>
              <div className={styles.downloadDetails}>
                  <div className={styles.downloadDetailsText}>
                      <h3>{words.software_Notes}</h3>
                      <p className={styles.downloadDetailsTextContent}>{castForPicoLists?.updateInfo}</p>
                      <h3>{words.software_New}</h3>
                      <p className={styles.downloadDetailsTextContent}>{castForPicoLists?.updateContent}</p>
                  </div>
                  <div className={styles.downloadDetailsText}>
                      <h3>{words.software_Requirements}</h3>
                      <p className={styles.downloadDetailsTextContent}>{castForPicoLists?.configurationRequirements}</p>
                  </div>
              </div>
          </Modal>
      </div>
      </>
    );
  };
  export default SoftwareFooter;
